/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'Verifications' store object.
 * @namespace VerificationsSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UAVerifications';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static fetchAcesVerifications = state =>
    state[selectors.moduleIdentifier].fetchAcesVerifications.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static isFetchingFetchAcesVerifications = state =>
    state[selectors.moduleIdentifier].isFetchingFetchAcesVerifications.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static fetchAcesVerificationsError = state =>
    state[selectors.moduleIdentifier].fetchAcesVerificationsError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static getAcesVerificationsByVerificationId = state =>
    state[selectors.moduleIdentifier].getAcesVerificationsByVerificationId.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static isFetchingGetAcesVerificationsByVerificationId = state =>
    state[selectors.moduleIdentifier].isFetchingGetAcesVerificationsByVerificationId.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static getAcesVerificationsByVerificationIdError = state =>
    state[selectors.moduleIdentifier].getAcesVerificationsByVerificationIdError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static postAcesVerificationsLinkFile = state =>
    state[selectors.moduleIdentifier].postAcesVerificationsLinkFile.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static isFetchingPostAcesVerificationsLinkFile = state =>
    state[selectors.moduleIdentifier].isFetchingPostAcesVerificationsLinkFile.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static postAcesVerificationsLinkFileError = state =>
    state[selectors.moduleIdentifier].postAcesVerificationsLinkFileError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static deleteAcesVerificationsFileLinksByLinkId = state =>
    state[selectors.moduleIdentifier].deleteAcesVerificationsFileLinksByLinkId.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static isFetchingDeleteAcesVerificationsFileLinksByLinkId = state =>
    state[selectors.moduleIdentifier].isFetchingDeleteAcesVerificationsFileLinksByLinkId.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static deleteAcesVerificationsFileLinksByLinkIdError = state =>
    state[selectors.moduleIdentifier].deleteAcesVerificationsFileLinksByLinkIdError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static postAcesVerificationsCreateCaseworkerTask = state =>
    state[selectors.moduleIdentifier].postAcesVerificationsCreateCaseworkerTask.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static isFetchingPostAcesVerificationsCreateCaseworkerTask = state =>
    state[selectors.moduleIdentifier].isFetchingPostAcesVerificationsCreateCaseworkerTask.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static postAcesVerificationsCreateCaseworkerTaskError = state =>
    state[selectors.moduleIdentifier].postAcesVerificationsCreateCaseworkerTaskError.payload;

  /**
   * Selects the data from the store
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static documentsSubmitted = state => state[selectors.moduleIdentifier].documentsSubmitted.payload;

  /**
   * Selects the data from the store
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static form = state => state[selectors.moduleIdentifier].form.payload;
}
